module.exports = __webpack_public_path__ + "media/images/winery-header-bbe44952dac5377b8b4d1454392f730b.jpg";